import mod from "-!./Confirm.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Confirm.js?vue&type=script&lang=js&"